var __WEBPACK_NAMESPACE_OBJECT__ = dependencies['@sitebase/theme-context']['1']['module'];